import * as S from "@dcspark/cardano-multiplatform-lib-nodejs";
import { hexToBytes } from "@sundae/cardano-utils";
export var AddressType;
(function (AddressType) {
    AddressType["Byron"] = "Byron";
    AddressType["Base"] = "Base";
    AddressType["Enterprise"] = "Enterprise";
    AddressType["Reward"] = "Reward";
    AddressType["Pointer"] = "Pointer";
})(AddressType || (AddressType = {}));
export const getAddressType = (a) => {
    switch (a.header() >> 4) {
        case S.AddressHeaderKind.Byron:
            return AddressType.Byron;
        case S.AddressHeaderKind.BasePaymentKeyStakeKey:
        case S.AddressHeaderKind.BasePaymentKeyStakeScript:
        case S.AddressHeaderKind.BasePaymentScriptStakeKey:
        case S.AddressHeaderKind.BasePaymentScriptStakeScript:
            return AddressType.Base;
        case S.AddressHeaderKind.PointerKey:
        case S.AddressHeaderKind.PointerScript:
            return AddressType.Pointer;
        case S.AddressHeaderKind.EnterpriseKey:
        case S.AddressHeaderKind.EnterpriseScript:
            return AddressType.Enterprise;
        case S.AddressHeaderKind.RewardKey:
        case S.AddressHeaderKind.RewardScript:
            return AddressType.Reward;
        default:
        // throw new Error(`Invalid address header type: ${a.header()}`);
    }
};
const AddressExtendedTypes = {
    [S.AddressHeaderKind.Byron]: "Byron",
    [S.AddressHeaderKind.BasePaymentKeyStakeKey]: "BasePaymentKeyStakeKey",
    [S.AddressHeaderKind.BasePaymentKeyStakeScript]: "BasePaymentKeyStakeScript",
    [S.AddressHeaderKind.BasePaymentScriptStakeKey]: "BasePaymentScriptStakeKey",
    [S.AddressHeaderKind.BasePaymentScriptStakeScript]: "BasePaymentScriptStakeScript",
    [S.AddressHeaderKind.EnterpriseKey]: "EnterpriseKey",
    [S.AddressHeaderKind.EnterpriseScript]: "EnterpriseScript",
    [S.AddressHeaderKind.PointerKey]: "PointerKey",
    [S.AddressHeaderKind.PointerScript]: "PointerScript",
    [S.AddressHeaderKind.RewardKey]: "RewardKey",
    [S.AddressHeaderKind.RewardScript]: "RewardScript",
};
export const getAddressExtendedType = (a) => AddressExtendedTypes[a.header() >> 4];
export const stakeCredToHashHex = (a) => (a.kind() === S.StakeCredKind.Key
    ? a.to_keyhash()
    : a.to_scripthash()).to_hex();
export const getStakeCredHashes = (a) => ({
    payment: a.payment_cred() ? stakeCredToHashHex(a.payment_cred()) : undefined,
    staking: a.staking_cred() ? stakeCredToHashHex(a.staking_cred()) : undefined,
});
export const addressToStakeCredentials = (addressBech32) => getStakeCredHashes(S.Address.from_bech32(addressBech32));
export const getAddressInfo = (addressBech32) => {
    const address = S.Address.from_bech32(addressBech32);
    const creds = getStakeCredHashes(address);
    const type = getAddressType(address);
    const extendedType = getAddressExtendedType(address);
    return { ...creds, type, extendedType, address };
};
export function addressToBech32(addressHex) {
    return S.Address.from_bytes(hexToBytes(addressHex)).to_bech32();
}
//# sourceMappingURL=addresses.js.map